var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"express_container"},[_vm._v(" 作为中国邮政速递股份有限公司（EMS）的指定国际运能供应商之一，也获得海关总署批准的进出境快件运营人资质，在全国各地展开商业性快件的进出口清关服务。 ")])}
var staticRenderFns = []

export { render, staticRenderFns }